<template>
  <el-tabs v-model="activeName" type="card">
    <!-- <el-tab-pane label="模版导入" name="first"> -->
      <el-row>
        <el-col :span="24">
          <el-form :inline="true" :model="filters" label-width="100px">
            <!--<el-form-item label="Status">
							<el-select v-model="filters.nType" placeholder="">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>-->
            <el-form-item>
              <!--<el-button type="primary" v-on:click="addTemplateFlag=true">
								Add
							</el-button>-->
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24">
          <el-table
            ref="multipleTable"
            :data="tableData"
            @row-click="toDetail"
            tooltip-effect="dark"
						style="width: 100%; border-radius: 20px 20px 0 0; overflow: hidden;"
						:header-cell-style="headerStyle"
            :cell-style="cellStyle"
          >
            <el-table-column
              prop="sTemplateName"
              label="Template  Name"
							align="center"
            ></el-table-column>
            <el-table-column prop="dTime" 	align="center" label="Create Time"></el-table-column>
            <el-table-column prop="sName" 	align="center" label="Create User"></el-table-column>
            <el-table-column prop="sTableName" 	align="center" label="Table Name">
              <template slot-scope="scope">
                {{ scope.row.sSchema }}.{{ scope.row.sTableName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="nUploadCnt"
              label="Uploads"
							align="center"
            ></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <div style="float: right; margin-top: 20px">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        title="View Template"
        :visible.sync="detailViewFlag"
        width="80%"
      >
        <div>
          <el-form :model="form" ref="form" label-width="160px">
            <el-form-item label="Template Name" prop="sTemplateName">{{
              form.sTemplateName
            }}</el-form-item>
            <el-form-item label="Schema" prop="sSchemaName">{{
              form.sSchema
            }}</el-form-item>
            <el-form-item label="Table Name" prop="sTemplateName">{{
              form.sTableName
            }}</el-form-item>
            <el-form-item
              label="Column Name."
              prop="sSchemaName"
              v-for="(item, index) in form.ziduanList"
            >
              <label>{{ item.sFieldName }}</label>
              <label>&nbsp;&nbsp;&nbsp;</label>
              {{ item.sFieldType }}
              <label v-if="item.sLen">({{ item.sLen }})</label>
              <label>&nbsp;&nbsp;&nbsp;</label>
              <label v-if="item.nPrimaryKey == 1">Primary Key</label>

              <label>{{ toConvit1(item.sIfnull, options3) }}</label>
              <label>&nbsp;&nbsp;&nbsp;</label>
              <template v-if="item.sIfnull == 1">
                <label>{{ toConvit3(item.sIfcheckValue, options4) }}</label>
                <label>&nbsp;&nbsp;&nbsp;</label>
                <label v-if="item.sIfcheckValue == 1">{{
                  toConvit2(item.sValueRange, options5)
                }}</label>
                <label v-else>{{ item.sValueRange }}</label>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="doDownLoad">Download Template</el-button>
          <el-button
            type="primary"
            @click="
              detailViewFlag = false;
              addTemplateFlag = true;
              detail.nTemplateId = form.nTemplateId;
            "
          >
            Upload Data
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="Upload Setting"
        :visible.sync="addTemplateFlag"
        width="80%"
      >
        <div>
          <el-form :model="detail" ref="form" label-width="160px">
            <!--<el-form-item label="Operation  Name" prop="sName">
							<el-input v-model="detail.sOperationName" placeholder="" style="width:220px;"></el-input>
						</el-form-item>-->
            <el-form-item label="File Name" prop="sFileName">
              <el-input
                v-model="detail.sFileName"
                readonly
                disabled
                placeholder="Please select file"
                style="width: 220px"
              ></el-input>
              <el-button class="upload-button">
                Select
                <input @change="changeFile" id="files" type="file" />
              </el-button>
            </el-form-item>
            <el-form-item label="File Format" prop="sSchemaName">
              <el-select v-model="detail.sFileFormat" placeholder="Select">
                <el-option
                  v-for="item in options1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="Delimiters"
              prop="sSchemaName"
              v-if="detail.sFileFormat == 'csv'"
            >
              <el-radio
                v-model="detail.sRadio"
                :label="item.id"
                v-for="item in options2"
                >{{ item.name }}</el-radio
              >
              <el-input
                v-if="detail.sRadio == 5"
                v-model="detail.sDelimiters"
                placeholder=""
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addTemplateFlag = false">Cancel</el-button>
          <el-button type="primary" @click="saveTemplate">Confirm</el-button>
        </span>
      </el-dialog>
    <!-- </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import {
  selectUploadTemplatePage,
  selectTemplateFieldList,
  importTemplate,
  getUploadTemplateByRoleListPage,
  getCurrencyCheckRulePage,
} from "../../api/api";
export default {
  data() {
    return {
      activeName: "first",
      addTemplateFlag: false,
      detailViewFlag: false,
      filters: {
        pageSize: 10,
        currentPage: 1,
      },
      form: {},
      detail: {
        sRadio: "",
        sFileFormat: "",
        nTemplateId: "",
        sDelimiters: "",
        sFileName: "",
        sOperationName: "",
      },
      total: 0,
      options1: [
        {
          id: "csv",
          name: "csv",
        },
        {
          id: "xlsx",
          name: "xlsx",
        },
      ],
      options2: [
        {
          id: ",",
          name: "Comma",
        },
        {
          id: ";",
          name: "Semicolon",
          //				}, {
          //					id: ';',
          //					name: "Tab"
          //				}, {
          //					id: '&',
          //					name: "Space"
        },
        {
          id: 5,
          name: "Other",
        },
      ],
      options3: [
        {
          id: "0",
          name: "Null Able",
        },
        {
          id: "1",
          name: "Not Null",
        },
      ],
      options4: [
        {
          id: "1",
          name: "Using",
        },
        {
          id: "2",
          name: "=",
        },
        {
          id: "3",
          name: "In",
        },
      ],
      options5: [],
			tableData: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px",
      },
      cellStyle: {
        height: "55px",
      },
    };
  },
  mounted() {
    this.getList();

    getCurrencyCheckRulePage({
      currentPage: 1,
      pageSize: 9999,
    }).then((res) => {
      this.options5 = res.data;
    });
  },
  methods: {
    toConvit3(val, arr) {
      if (val == 0) {
        return;
      }
      const one = arr.find((one) => one.id == val);
      if (one) {
        return one.name;
      }
    },
    toConvit1(val, arr) {
      const one = arr.find((one) => one.id == val);
      if (one) {
        return one.name;
      }
    },
    toConvit2(val, arr) {
      const one = arr.find((one) => one.nId == val);
      if (one) {
        return one.sRuleName;
      }
    },
    saveTemplate() {
      if (this.detail.sFileFormat == "csv") {
        if (!this.detail.sRadio) {
          this.$message.error("Please select the delimiters");
          return;
        }
      }
      //				if(!this.detail.sOperationName) {
      //					this.$message.error('Please enter the operation name');
      //					return;
      //				}

      var fdata = new FormData();

      fdata.append("file", document.getElementById("files").files[0]);
      fdata.append("nTemplateId", this.detail.nTemplateId);
      fdata.append("sFileFormat", this.detail.sFileFormat);
      fdata.append(
        "sDelimiters",
        this.detail.sFileFormat !== "csv"
          ? ","
          : this.detail.sRadio == 5
          ? this.detail.sDelimiters
          : this.detail.sRadio
      );
      fdata.append(
        "sOperationName",
        sessionStorage.getItem("userId") +
          "_" +
          new Date().Format("yyyyMMddhhmmss")
      );
      //fdata.append('sOperationName', this.detail.sOperationName);

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      importTemplate(fdata)
        .then((res) => {
          this.getList();
          this.$message("import Success");
          this.addTemplateFlag = false;
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    createCSVStr(outFieldsNames) {
      var textField = '"';
      var content = "";
      var len = 0,
        n = 0,
        comma = "",
        value = "";
      try {
        outFieldsNames.forEach(function (_field) {
          content = content + comma + _field;
          comma = ",";
        });
        content = content + "\r\n";
        len = outFieldsNames.length;
        n = outFieldsNames.length;
        for (var i = 0; i < len; i++) {
          comma = "";
          for (var m = 0; m < n; m++) {
            var _field = outFieldsNames[m];
            value = outFieldsNames[i][_field];
            if (!value && typeof value !== "number") {
              value = "";
            }
            //在这里我做了一些过滤，过滤条件是根据自己内容设计的
            if (value && /[",\r\n]/g.test(value)) {
              value = textField + value.replace(/(")/g, '""') + textField;
            }
            try {
              value = value.replace(/\r\n/g, "").value.replace(/\n/g, "");
            } catch (e) {}
            content = content + comma + value;
            comma = ",";
          }
          content = content + "\r\n";
        }
      } catch (err) {
        content = "";
      }
      return content;
    },
    doDownLoad() {
      selectTemplateFieldList({
        nTemplateId: this.form.nTemplateId,
      }).then((res) => {
        var ziduanList = [];
        res.data.forEach((one) => {
          if (one.sFieldName !== "LOAD_DT") {
            ziduanList.push(one.sFieldName);
          }
        });
        var blob = new Blob(["\ufeff" + this.createCSVStr(ziduanList)], {
          type: "text/csv",
        });
        var alink = document.createElement("a");
        alink.setAttribute("href", URL.createObjectURL(blob));
        alink.target = "_blank";
        alink.download =
          this.form.sTemplateName + "_" + new Date().getTime() + ".csv";
        alink.click();
      });
    },
    toDetail(data) {
      selectTemplateFieldList({
        nTemplateId: data.nTemplateId,
      }).then((res) => {
        var ziduanList = [];
        res.data.forEach((one) => {
          if (!one.templateFieldCheck) {
            one.templateFieldCheck = {
              sIfnull: "0",
              typeF: 0,
              sIfcheckValue: "",
              sValueRange: "",
            };
          } else {
            one.templateFieldCheck.sIfcheckValue =
              one.templateFieldCheck.sIfcheckValue == 0
                ? ""
                : one.templateFieldCheck.sIfcheckValue;
          }
          if (one.sFieldType.indexOf("varchar") > -1) {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: "varchar",
              sLen: one.sFieldType
                .replace(/varchar\(/gi, "")
                .replace(/\)/gi, ""),
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange,
            });
          } else if (one.sFieldType.indexOf("decimal") > -1) {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: "decimal",
              sLen: one.sFieldType
                .replace(/decimal\(/gi, "")
                .replace(/\)/gi, ""),
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange,
            });
          } else {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: one.sFieldType,
              sLen: "",
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange,
            });
          }
        });

        this.form = {
          nTemplateId: data.nTemplateId,
          sTemplateName: data.sTemplateName,
          sSchema: data.sSchema,
          sTableName: data.sTableName,
          ziduanList: ziduanList,
        };
        this.detailViewFlag = true;
      });
    },
    handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },
    reGetList: function () {
      this.filters.currentPage = 1;
      this.getList();
    },
    getList: function () {
      var param = Object.assign({}, this.filters);
      getUploadTemplateByRoleListPage(param).then((res) => {
        this.tableData = res.data;
        this.total = res.page.totalCount * 1;
      });
    },
    changeFile(e) {
      var self = this;
      var files = document.getElementById("files").files;
      if (files.length) {
        var file = files[0];
        self.detail.sFileName = file.name;
        var arr = file.name.split(".");
        if ("csv;xls;xlsx;".indexOf(arr[arr.length - 1]) === -1) {
          self.$message({
            message: "Please Select right file",
            type: "error",
            duration: 5 * 1000,
          });
        } else {
          if ("csv".indexOf(arr[arr.length - 1]) > -1) {
            this.detail.sType = 1;
          } else if ("xls".indexOf(arr[arr.length - 1]) > -1) {
            this.detail.sType = 2;
          } else {
            this.detail.sType = 3;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.upload-button {
  position: relative;
  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// template.vue?44dffc83